package com.macrofocus.common.collection

// ToDo: make cross platform
class WeakReference<T>(val referent: T) {
    fun get(): T? {
        return referent
    }
}